import { render, staticRenderFns } from "./ResetPasswordModal.vue?vue&type=template&id=08d973c3&"
import script from "./ResetPasswordModal.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports